import { render, staticRenderFns } from "./ProductPreview.vue?vue&type=template&id=ef382b26&scoped=true&"
import script from "./ProductPreview.vue?vue&type=script&lang=ts&"
export * from "./ProductPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPreview.vue?vue&type=style&index=0&id=ef382b26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef382b26",
  null
  
)

export default component.exports